// extracted by mini-css-extract-plugin
export default {"badge":"eRdNw","size-small":"qhA5k","sizeSmall":"qhA5k","size-normal":"IfOeV","sizeNormal":"IfOeV"};